import styled from 'styled-components';
import { media } from 'src/components/base';

export const StyledArticleHeading = styled.h1`
  font-size: 1.6rem;
  line-height: 1.4;
  margin: 0 0 1rem;

  ${media.largeUp`
    margin-bottom: 1.2rem;
  `}
`;

export const StyledArticle = styled.article`
  font-size: 1.15rem;
  color: ${p => p.theme.text.primary};

  figure {
    margin-bottom: 1rem;
    img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
    }
    figcaption {
      color: ${p => p.theme.text.secondary};
      text-align: right;
    }
  }
  ${StyledArticleHeading} {
    font-size: 1.6rem;
  }
  h2 {
    font-size: 1.3rem;
  }
  h3 {
    font-size: 1.15rem;
  }
  h4 {
    margin-bottom: 1rem;
  }
  ol,
  ul {
    list-style-position: inside;
    line-height: 1.6;
  }
  p {
    line-height: 1.6;
  }
  a {
    color: ${p => p.theme.text.linkExternal};
    text-decoration: underline;
  }
  .caption {
    text-align: right;
  }

  ${media.largeUp`
    h4 {margin-bottom: 1.4rem;}
  `}
`;

export const Preamble = styled.p`
  font-size: 1.15rem;
  font-weight: 600;
`;
